/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery', 'pip-model'], function ($, pip) {

    var assemblyMessagingSelector = '#buybox__in-store-assembly';
    var inStoreAssemblyTemplate = $('#in-store-assembly').html();
    var deliveryFromStoreAssemblyTemplate = $('#delivery-from-store-assembly').html();
    var deliveryAndInStoreAssemblyTemplate = $('#delivery-and-in-store-assembly').html();

    function renderInStoreAssemblyMessaging() {
        if (pip.features.bodfsGrillsAssemblyEnabled && pip.fulfillment && pip.fulfillment.shipping && pip.fulfillment.shipping.buyOnlineDeliverFromStore){
            if (pip.inStoreAssemblyAvailable && pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAssemblyEligible) {
                $(assemblyMessagingSelector).html(deliveryAndInStoreAssemblyTemplate);
            } else if (pip.inStoreAssemblyAvailable && !pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAssemblyEligible){
                $(assemblyMessagingSelector).html(inStoreAssemblyTemplate);
            } else if (!pip.inStoreAssemblyAvailable && pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAssemblyEligible){
                $(assemblyMessagingSelector).html(deliveryFromStoreAssemblyTemplate);
            }
        } else{
            if (pip.inStoreAssemblyAvailable) $(assemblyMessagingSelector).html(inStoreAssemblyTemplate);
        }
    }
    return {
        init: function () {
            renderInStoreAssemblyMessaging();
        }
    }
});
}.call(window));